import { Box } from "@mui/material";
import { colorPrimary } from "../../../theme";

export const CancelButton = ({
  onClick,
  disabled = false,
}: {
  onClick?: () => void;
  disabled?: boolean;
}) => {
  return (
    <Box
      component="button"
      type="button"
      onClick={onClick}
      disabled={disabled}
      sx={{
        width: "250px",
        maxWidth: 180,
        maxHeight:180,
        px: 2,
        py: 1,
        borderRadius: 2,
        border: `1px solid ${colorPrimary}`,
        backgroundColor: "transparent",
        color: colorPrimary,
        fontWeight: 500,
        cursor: "pointer",
        transition: "all .2s ease",
        outline: "none",

        "&:hover": {
          backgroundColor: "rgba(255, 102, 0, 0.08)",
        },

        "&:disabled": {
          opacity: 0.5,
          cursor: "not-allowed",
        },
      }}
    >
      Cancelar
    </Box>
  );
};



export const SubmitButton = ({
  onClick,
  disabled = false,
  title,
  type = "submit",
  maxWidth,
}: {
  onClick?: () => void;
  disabled?: boolean;
  title?: string;
  type?: "button" | "submit" | "reset";
  maxWidth?: number;
  
}) => {
  return (
    <Box
      component="button"
      type={type}
      onClick={onClick}
      disabled={disabled}
      sx={{
        position: "relative",
        overflow: "hidden",
        width: "100%",
        maxWidth:maxWidth?? 180,
        maxHeight:180,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",

        borderRadius: 2,
        backgroundColor: colorPrimary,
        color: "#fff",
        padding: "16px",
        fontWeight: 600,
        border: "none",
        cursor: "pointer",
        outline: "none",

        zIndex: 1,

        "&::before": {
          content: '""',
          position: "absolute",
          width: 0,
          height: 0,
          left: "50%",
          top: "50%",
          backgroundColor: "#000",
          borderRadius: "50%",
          transform: "translate(-50%, -50%)",
          transition:
            "width 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94), height 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)",
          zIndex: -1,
        },

        "&:hover::before": {
          width: 300,
          height: 300,
        },

        "&:disabled": {
          opacity: 0.5,
          cursor: "not-allowed",
        },
      }}
    >
    {title ?? "Salvar"}  
    </Box>
  );
};
